import Utils from "../Utils";
import services from "../services";
import store from "../store";
import i18n from "./../i18n.js";

const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const strict = true;
const getDefaultState = () => {
  return {
    hfUserRoles: [],
    hfOffices: [],
    hf: {},
    generalInfo: {},
    officeId: "",
    sanimpresaOffice: false
  };
};
const state = getDefaultState();

const getters = {
  getHfUserRoles: state => state.hfUserRoles,
  selectedHfOffice: state => {
    return state.hfOffices.find(office => office.id == state.officeId);
  },
  hfOffices: state => state.hfOffices,
  hf: state => state.hf,
  generalInfo: state => state.generalInfo,
  timeTableItems: state => state.generalInfo.timeTableItems,
  officeId: state => state.officeId,
  isSanimpresaOffice: state => state.sanimpresaOffice
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  RESET_USER_SESSION(state) {
    store.dispatch(
      "clearAll",
      { whiteList: ["auth", "session", "error", "hfManagement", "loading"] },
      {
        root: true
      }
    );
  },
  SET_USER_ROLES(state, roles) {
    let refIndex = roles.indexOf("REFERENT");
    if (refIndex > -1) {
      roles.splice(refIndex, 1);
    }
    let lrIndex = roles.indexOf("LEGALRAPRESENTATIVE");
    if (lrIndex > -1) {
      roles.splice(lrIndex, 1);
    }
    let rolesLocalized = [];
    for (let r of roles) {
      let localizedRole = i18n ? i18n.t("userRoles.".concat(r)) : r;
      rolesLocalized.push(localizedRole);
    }
    rolesLocalized.sort((a, b) => (a > b ? 1 : -1));
    state.hfUserRoles = rolesLocalized;
  },
  SET_OFFICE_ID(state, officeId) {
    state.officeId = officeId;
  },
  SET_SANIMPRESA_OFFICE(state, value) {
    state.sanimpresaOffice = value;
  },
  SET_HF_OFFICES(state, hfOffices) {
    state.hfOffices = hfOffices;
  },
  SET_HF(state, hf) {
    state.hf = hf;
  },
  generalInfo(state, generalInfo) {
    state.generalInfo = generalInfo;
  }
};

const actions = {
  async resetUserSession({ commit }) {
    await commit("RESET_USER_SESSION");
  },
  getHF({ commit }, hfId) {
    return services.hfManagementService
      .fetchHF(hfId)
      .then(hfInfoContainer => {
        commit("SET_HF", hfInfoContainer.hf);
        commit("SET_HF_OFFICES", hfInfoContainer.listHfOfficeInfo);
        return hfInfoContainer;
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  getGeneralInfo({ commit }, officeId) {
    return services.hfManagementService
      .fetchGeneralInfo(officeId)
      .then(generalInfo => {
        commit("generalInfo", generalInfo);
        return generalInfo;
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      });
  },
  updateOfficeGeneralInfo({ commit }, { officeId, officeGeneralInfo }) {
    return services.hfManagementService
      .updateOfficeGeneralInfo(officeId, officeGeneralInfo)
      .then(() => {})
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  async exportOfficeStaffExcelFile({ commit, getters }) {
    try {
      const officeId = getters["officeId"];
      const { data } =
        await services.hfManagementService.generateOfficeDoctorsExcelFile(
          officeId
        );
      const hfOffices = getters["hfOffices"];
      const officeName = hfOffices.find(o => o.id == officeId).legalName;
      Utils.downloadBlob(
        data,
        `Medici della struttura ${Utils.sanitizeFileName(officeName)}.xlsx`,
        data?.type || XLSX_MIME
      );
    } catch (reason) {
      commit("error/SET_ERROR", Utils.toErrorPayload(reason), { root: true });
      throw reason;
    }
  },
  async exportOfficeServicesExcelFile({ commit, getters }) {
    try {
      const officeId = getters["officeId"];
      const { data } =
        await services.hfManagementService.generateOfficeServicesExcelFile(
          officeId
        );
      const hfOffices = getters["hfOffices"];
      const officeName = hfOffices.find(o => o.id == officeId).legalName;
      Utils.downloadBlob(
        data,
        `Servizi della struttura ${Utils.sanitizeFileName(officeName)}.xlsx`,
        data?.type || XLSX_MIME
      );
    } catch (reason) {
      commit("error/SET_ERROR", Utils.toErrorPayload(reason), { root: true });
      throw reason;
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
